<template>
  <div class="right-sidebar">
    <div class="config-header">
      <div class="header-main">
        <div class="header-left">
          <div class="header-icon">
            <SvgAsset :content="sidebarConfigBookSvg" />
          </div>
          <div class="header-copy">
            <span class="header-title">{{ $t('base_set_config') }}</span>
          </div>
        </div>

        <div class="header-main-right">
          <div class="window-controls" v-if="isElectron()">
            <button class="window-btn" :title="$t('minimize') || 'Minimize'" @click="min">
              <SvgAsset :content="windowMinimizeSvg" />
            </button>
            <button class="window-btn" :title="windowControlTitle" @click="max">
              <SvgAsset v-if="!isWindowMaximized" :content="windowMaximizeSvg" />
              <SvgAsset v-else :content="windowRestoreSvg" />
            </button>
            <button class="window-btn close-btn" :title="$t('close') || 'Close'" @click="out">
              <SvgAsset :content="windowCloseSvg" />
            </button>
          </div>
        </div>
      </div>

      <div class="header-actions" v-if="isSupportExport">
        <div class="header-actions-label"></div>
        <div class="action-item action-item-wide">
          <import_config :title="$t('import_config')" />
          <div class="tip_bubble">{{ $t('import_config') }}</div>
        </div>
        <div class="action-item action-item-wide">
          <export_config :title="$t('export_config')" />
          <div class="tip_bubble">{{ $t('export_config') }}</div>
        </div>
      </div>
    </div>

    <div class="config-list scrollbar_thumb" ref="configListRef">
      <transition-group name="list-complete">
        <div v-for="(item, index) in configSet.configList.value" :key="item.Name + index" class="config-item" :class="{ active: index == configSet.currentConfig.value }" @click="change(index)">
          <div v-if="index == configSet.currentConfig.value" class="active-rail"></div>

          <div class="item-content">
            <input v-if="disabledMap[index] == true" ref="isFocus" class="config-input" type="text" v-model="rename" :placeholder="$t('config_placeholder')" @blur="changeName(index)" @click.stop />
            <div v-else class="item-copy">
              <span class="item-name" :title="item.Name">{{ item.Name }}</span>
              <span class="item-meta">#{{ String(index + 1).padStart(2, '0') }}</span>
              <div class="item-progress" aria-hidden="true">
                <div class="item-progress-bar"></div>
              </div>
            </div>
          </div>

          <div class="item-actions" v-if="disabledMap[index] != true">
            <div
              class="action-btn shortcut"
              v-if="configSet.isFeatureSupported"
              @click.stop="setBind(index)"
              :title="item.ShortcutRet == false && item.Shortcut != null && item.Shortcut.length > 0 ? t('hot_key_registered') : getShortcutTitle(item.Shortcut)"
              :class="{
                'has-shortcut': item.Shortcut && item.Shortcut.length > 0,
                error: item.ShortcutRet == false && item.Shortcut != null && item.Shortcut.length > 0,
                success: item.ShortcutRet == true && item.Shortcut != null && item.Shortcut.length > 0,
              }"
            >
              <SvgAsset :content="configShortcutSvg" />
            </div>
            <div class="action-btn" @click.stop="editName(index)" :title="$t('config_rename')">
              <SvgAsset :content="configEditSvg" />
            </div>
            <div class="action-btn delete" v-if="index != configSet.currentConfig.value" @click.stop="deleteConfig(index)" :title="$t('config_delete')">
              <SvgAsset :content="configDeleteSvg" />
            </div>
          </div>
        </div>
      </transition-group>

      <div class="config-item add-config" @click="addConfig" v-if="configSet.configList.value.length < 6">
        <div class="plus-icon">
          <SvgAsset :content="actionPlusSvg" />
        </div>
        <span>{{ $t('config_create_title') }}</span>
      </div>
    </div>

    <div class="config-footer-fixed" v-if="configSet.configList.value.length >= 6">
      <div class="config-item add-config" @click="addConfig">
        <div class="plus-icon">
          <SvgAsset :content="actionPlusSvg" />
        </div>
        <span>{{ $t('config_create_title') }}</span>
      </div>
    </div>

    <!-- Zoomer 鎺ㄨ崘鍏ュ彛锛氶珮鎰熷害娌夋蹈寮忓崱鐗?-->
    <div class="zoomer-recommend-card" v-if="isRA68" @click="addZoomerConfig">
      <div class="zoomer-image-container">
        <img src="@/assets/zoomer.webp" alt="zoomer" class="zoomer-main-img" />
      </div>

      <!-- 娓愬彉娴佸厜鑳屾櫙灞?-->
      <div class="zoomer-glow-layer"></div>

      <!-- 鍙充笂瑙掓瀬绠€瑁呴グ鏍?-->
      <div class="zoomer-minimal-badge">
        <span class="dot"></span>
        <span class="label">{{ $t('zoomer_recommend') }}</span>
      </div>

      <div class="zoomer-hover-overlay">
        <div class="overlay-content">
          <div class="download-icon-wrapper">
            <SvgAsset :content="actionDownloadSvg" />
            <div class="icon-glow"></div>
          </div>
          <div class="download-text-group">
            <span class="main-text">{{ $t('one_click_export_config') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="config-footer"></div>
    <shortcon_key v-if="configSet.isShowShortcon == true" :keys="bindKeys" :index="bindIndex" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import { configSet } from '@/service/driver/config_set'
import import_config from '../operation_config/import_config.vue'
import export_config from '../operation_config/export_config.vue'
import { DeviceManager, DeviceProtocol } from '@/service/device'
import { DialogType, enableDialog } from '../cdialog/dialog'
import i18n from '@/languages/i18n'
import { VK } from '@/define/define'
import { getStringAfterDash } from '@/tool/utility'
import { kbVKTexture } from '@/define/vkcode'
import shortcon_key from '../operation_config/shortcon_key.vue'
import { DevicePid } from '@/define/define'
import { trackEvent } from '@/activitylog/activitylog'
import { PRESET_CONFIGS } from '@/define/presets'
import { isElectron } from '@libs/utils/envUtils'
import SvgAsset from '../common/SvgAsset.vue'
import actionDownloadSvg from '@/assets/inline-svg/action-download.svg?raw'
import actionPlusSvg from '@/assets/inline-svg/action-plus.svg?raw'
import configDeleteSvg from '@/assets/inline-svg/config-delete.svg?raw'
import configEditSvg from '@/assets/inline-svg/config-edit.svg?raw'
import configShortcutSvg from '@/assets/inline-svg/config-shortcut.svg?raw'
import sidebarConfigBookSvg from '@/assets/inline-svg/sidebar-config-book.svg?raw'
import windowCloseSvg from '@/assets/inline-svg/window-close.svg?raw'
import windowMaximizeSvg from '@/assets/inline-svg/window-maximize.svg?raw'
import windowMinimizeSvg from '@/assets/inline-svg/window-minimize.svg?raw'
import windowRestoreSvg from '@/assets/inline-svg/window-restore.svg?raw'
const { t } = i18n.global
const disabledMap = ref<{ [key: number]: boolean }>({})
const rename = ref('')
const isFocus = ref<HTMLInputElement[] | null>(null)
const configListRef = ref<HTMLElement | null>(null)
const bindIndex = ref(0)
const bindKeys = ref<VK[]>([])
const isWindowMaximized = ref(false)

const syncWindowMaximizedState = async () => {
  if (!isElectron()) {
    isWindowMaximized.value = false
    return
  }
  isWindowMaximized.value = Boolean(await electronAPI.wnd('isMaximized'))
}

const handleWindowResize = () => {
  void syncWindowMaximizedState()
}

const windowControlTitle = computed(() => (isWindowMaximized.value ? t('restore') || 'Restore' : t('maximize') || 'Maximize'))

onMounted(() => {
  void syncWindowMaximizedState()
  if (isElectron()) {
    window.addEventListener('resize', handleWindowResize)
  }
  setTimeout(() => {
    nextTick(() => {
      if (configListRef.value) {
        configListRef.value.scrollTo({
          top: configListRef.value.scrollHeight,
          behavior: 'smooth',
        })
      }
    })
  }, 300)
})

onUnmounted(() => {
  if (isElectron()) {
    window.removeEventListener('resize', handleWindowResize)
  }
})

const isRA68 = computed(() => {
  const currentPid = DeviceManager.instance.state.currentPid
  return currentPid === DevicePid.IROKRA68 || currentPid === DevicePid.IROKRA68_1
})

const trackAddPresetConfig = async () => {
  if (import.meta.env.PROD == false) return
  if (i18n.global.locale == 'zh') {
    trackEvent('add_zoomer_config')
  }
}
// 1 鐭ラ亾琛岀▼锛屼慨鏀硅绋嬶紝淇敼鏀归敭
// 2 閰嶇疆鐩稿悓鐨勯厤缃紝鐒跺悗瀵煎叆
const addZoomerConfig = async () => {
  const currentPid = DeviceManager.instance.state.currentPid
  await configSet.setConfigPreset(PRESET_CONFIGS.TITLT, currentPid === DevicePid.IROKRA68 ? PRESET_CONFIGS.JINGTAIVA_RA68_ZOOMER : PRESET_CONFIGS.HUOCHAIREN_RA68_ZOOMER)
  await configSet.apiChangeConfig(configSet.configList.value.length - 1)
  trackAddPresetConfig()
  nextTick(() => {
    if (configListRef.value) {
      configListRef.value.scrollTo({
        top: configListRef.value.scrollHeight,
        behavior: 'smooth',
      })
    }
  })
}

const isSupportExport = computed(() => {
  return DeviceManager.instance.state.driverProtocol == DeviceProtocol.hid_web
})
const getShortcutTitle = (vk: VK[]) => {
  if (vk == null) {
    return ''
  }
  const title: string[] = []
  vk.filter((e) => e > 0).forEach((v) => title.push(getStringAfterDash(kbVKTexture[v])))
  return title.join('+')
}

const setBind = (index: number) => {
  configSet.isShowShortcon = true
  bindIndex.value = index
  bindKeys.value = configSet.configList.value[index].Shortcut || []
}

const change = (index: number) => {
  if (disabledMap.value[index]) return
  if (configSet.currentConfig.value === index) return
  configSet.apiChangeConfig(index)
}

const editName = (index: number) => {
  disabledMap.value[index] = true
  rename.value = configSet.configList.value[index].Name
  nextTick(() => {
    if (isFocus.value && isFocus.value[0]) {
      isFocus.value[0].focus()
    }
  })
}

const changeName = async (index: number) => {
  disabledMap.value[index] = false
  if (rename.value.trim().length === 0 || rename.value === configSet.configList.value[index].Name) {
    return
  }
  await configSet.apiReName(index, rename.value)
  enableDialog(t('rename_success'), DialogType.notice, true)
}

const deleteConfig = async (index: number) => {
  if (index == configSet.currentConfig.value) {
    enableDialog(t('config_set_delete_message'), DialogType.notice, true)
    return
  }
  const confirm = await enableDialog(t('delete_config_message'), DialogType.confirm)
  if (confirm) {
    try {
      await configSet.apiDelete(index)
      enableDialog(t('delete_config_success'), DialogType.notice, true)
    } catch (e) {
      configSet.apiConfigList()
      enableDialog(t('delete_config_fail'), DialogType.notice, false)
    }
  }
}

const addConfig = async () => {
  await configSet.apiAddConfig()
  nextTick(() => {
    if (configListRef.value) {
      configListRef.value.scrollTo({
        top: configListRef.value.scrollHeight,
        behavior: 'smooth',
      })
    }
  })
}

const min = () => electronAPI.min()
const max = async () => {
  const maximized = Boolean(await electronAPI.wnd('isMaximized'))
  await electronAPI.wnd(maximized ? 'unmaximize' : 'maximize')
  isWindowMaximized.value = !maximized
}
const out = () => electronAPI.close()
</script>

<style lang="less" scoped>
.right-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  flex-shrink: 0;
  padding: 24px 18px 18px;
  background: rgba(255, 255, 255, 0.08); /* 鍙充晶杈规爮: 鑳屾櫙 */
  backdrop-filter: blur(25px); /* 姣涚幓鐠冪壒鏁?*/
  overflow: hidden; /* 杩欓噷蹇呴』鏄?hidden锛岄槻姝骇鐢熷灞傛粴鍔ㄦ潯 */
  animation: sidebar-in 0.6s var(--transition-base);

  .config-header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 2px 14px;
    background: transparent;
    border-radius: 0;
    margin: 0 0 16px 0;
    border-bottom: none;
    color: var(--sidebar-text);
    box-shadow: none;
    transition: var(--transition-base);
    position: relative;
    z-index: 1;

    &:hover {
      transform: none;
      box-shadow: none;
    }

    .header-main {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      min-width: 0;
    }

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
      flex: 1;

      .header-copy {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
      }
    }

    .header-main-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      flex-shrink: 0;
      -webkit-app-region: no-drag;
    }

    .window-controls {
      display: flex;
      align-items: center;
      gap: 4px;

      .window-btn {
        width: 30px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: var(--radius-m);
        background: transparent;
        color: var(--sidebar-text-muted);
        cursor: pointer;
        transition: var(--transition-base);

        .svg_asset,
        svg {
          width: 14px;
          height: 14px;
          stroke: currentColor;
          stroke-width: 2;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.06);
          color: var(--color-dark);
        }
      }
    }

    .header-actions {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) minmax(0, 1fr);
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 6px 0 0;

      .header-actions-label {
        color: var(--sidebar-text-muted);
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 0.16em;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .action-item {
        position: relative;
        min-width: 0;

        &:hover {
          .tip_bubble {
            opacity: 1;
            visibility: visible;
            transform: translateX(-50%) translateY(0);
          }
        }
      }

      .action-item-wide {
        width: 100%;
      }

      .tip_bubble {
        position: absolute;
        top: calc(100% + 10px);
        left: 50%;
        transform: translateX(-50%) translateY(10px);
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(10px);
        color: #fff;
        padding: 6px 10px;
        border-radius: var(--radius-s);
        font-size: 11px;
        font-weight: 500;
        white-space: nowrap;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
        z-index: 1000;

        &::after {
          content: '';
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          border: 5px solid transparent;
          border-bottom-color: rgba(0, 0, 0, 0.85);
        }
      }

      :deep(.mgx_action_btn) {
        width: 100%;
        min-height: 34px;
        padding: 0 12px;
        min-width: 0;
        justify-content: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.52);
        border: 1px solid rgba(255, 255, 255, 0.44);
        border-radius: var(--radius-m);
        color: var(--sidebar-text);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

        &:hover {
          transform: translateY(-2px);
          background: rgba(255, 255, 255, 0.9);
          color: var(--brand-color-pure);
          box-shadow: 0 10px 18px rgba(0, 0, 0, 0.06);
        }

        .icon-wrapper {
          margin: 0;
          flex-shrink: 0;

          .svg_asset,
          svg {
            width: 14px;
            height: 14px;
          }
        }

        span {
          display: inline;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
      }
    }

    .header-icon {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      background: rgba(var(--color-brand-1-rgb), 0.12);
      flex-shrink: 0;

      .svg_asset,
      svg {
        width: 18px;
        height: 18px;
      }
    }

    .header-title {
      font-size: 11px;
      font-weight: 900;
      letter-spacing: 0.18em;
      color: var(--color-dark);
      text-transform: uppercase;
    }
  }

  @media (max-width: 1360px) {
    .config-header {
      .header-actions {
        grid-template-columns: 1fr 1fr;

        .header-actions-label {
          grid-column: 1 / -1;
        }
      }
    }
  }

  .zoomer-recommend-card {
    position: relative;
    bottom: auto;
    margin: 10px 0 22px 0;
    cursor: pointer;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
    border-radius: var(--radius-l); /* 浣跨敤鏇村ぇ鐨勫渾瑙?*/
    flex-shrink: 0;
    overflow: hidden;

    .zoomer-image-container {
      flex: 1;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      min-height: 0;
      transition: transform 0.6s var(--transition-base);
    }

    .zoomer-main-img {
      max-width: 100%;
      object-fit: cover;
      transform: scale(1.01);
      transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .zoomer-glow-layer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle at 50% 120%, rgba(var(--color-brand-1-rgb), 0.15), transparent 70%);
      pointer-events: none;
      z-index: 1;
    }

    .zoomer-minimal-badge {
      position: absolute;
      top: 14px;
      right: 14px;
      padding: 5px 10px;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 6px;
      display: flex;
      align-items: center;
      gap: 6px;
      z-index: 3;
      transition: all 0.4s var(--transition-base);

      .dot {
        width: 4px;
        height: 4px;
        background: var(--brand-color-pure);
        border-radius: 50%;
        box-shadow: 0 0 8px var(--brand-color-pure);
        animation: pulse 2s infinite;
      }

      .label {
        color: #fff;
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.8px;
        text-transform: uppercase;
      }
    }

    .zoomer-hover-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.35); /* 鏋佺畝娣辫壊閬僵 */
      backdrop-filter: blur(2px) saturate(120%);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: all 0.5s var(--transition-base);
      z-index: 4;

      .overlay-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(10px);
        transition: transform 0.5s var(--transition-base);

        .download-icon-wrapper {
          position: relative;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;

          .svg_asset,
          svg {
            width: 28px;
            height: 28px;
            z-index: 1;
          }

          .icon-glow {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 40px;
            height: 40px;
            background: var(--brand-color-pure);
            border-radius: 50%;
            filter: blur(15px);
            opacity: 0.6;
          }
        }

        .download-text-group {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;

          .main-text {
            color: #fff;
            font-size: 15px;
            font-weight: 700;
            letter-spacing: 0.5px;
          }

          .sub-text {
            color: rgba(255, 255, 255, 0.5);
            font-size: 9px;
            font-weight: 600;
            letter-spacing: 1px;
          }
        }
      }
    }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);

      .zoomer-minimal-badge {
        opacity: 0;
        transform: translateY(-5px);
      }

      .zoomer-main-img {
        transform: scale(1.1);
      }

      .zoomer-hover-overlay {
        opacity: 1;
        .overlay-content {
          transform: translateY(0);
        }
      }
    }

    &:active {
      transform: translateY(-4px) scale(0.98);
    }
  }

  .config-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    &::-webkit-scrollbar {
      width: 4px;
      display: block !important; /* 寮哄埗鏄剧ず */
    }

    &::-webkit-scrollbar-track {
      background: transparent !important;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1) !important;
      border-radius: var(--radius-pill);
      transition: var(--transition-base);

      &:hover {
        background: rgba(0, 0, 0, 0.16) !important;
      }
    }
  }

  .config-footer-fixed {
    padding: 4px 2px 20px;
    background: transparent;
    flex-shrink: 0;
  }

  .config-item {
    padding: 18px 18px 16px;
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(16px);
    border-radius: var(--radius-m);
    border: 1px solid rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
    flex-shrink: 0;

    .active-rail {
      position: absolute;
      left: 0;
      top: 50%;
      width: 5px;
      height: 42px;
      border-radius: 0 var(--radius-pill) var(--radius-pill) 0;
      background: var(--brand-color-pure);
      box-shadow: 2px 0 10px rgba(var(--color-brand-1-rgb), 0.25);
      transform: translateY(-50%) scaleY(0.78);
      transform-origin: center;
      transition:
        transform 0.45s cubic-bezier(0.23, 1, 0.32, 1),
        box-shadow 0.45s cubic-bezier(0.23, 1, 0.32, 1);
    }

    .item-content {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
      z-index: 1;

      .item-copy {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      .item-name {
        font-family: var(--font-main);
        font-size: 11px;
        color: rgba(34, 34, 34, 0.66);
        font-weight: 900;
        letter-spacing: 0.08em;
        line-height: 1.15;
        text-transform: uppercase;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: var(--transition-base);
      }

      .item-meta {
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 0.16em;
        line-height: 1;
        color: rgba(106, 114, 130, 0.68);
        text-transform: uppercase;
        transition: var(--transition-base);
      }

      .item-progress {
        position: relative;
        width: 100%;
        height: 4px;
        margin-top: 4px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: var(--radius-pill);
        overflow: hidden;

        .item-progress-bar {
          width: 0;
          height: 100%;
          border-radius: inherit;
          background: var(--brand-color-pure);
          opacity: 0.9;
          transition:
            width 0.7s cubic-bezier(0.23, 1, 0.32, 1),
            opacity 0.4s cubic-bezier(0.23, 1, 0.32, 1),
            box-shadow 0.4s cubic-bezier(0.23, 1, 0.32, 1);
          box-shadow: 0 0 0 rgba(var(--color-brand-2-rgb), 0);
        }
      }

      .config-input {
        flex: 1;
        background: transparent;
        border: none;
        border-bottom: 2px solid var(--brand-color-pure);
        padding: 2px 0;
        font-size: 13px;
        font-family: var(--font-main);
        font-weight: 700;
        color: var(--brand-color-pure);
        outline: none;

        &::placeholder {
          color: rgba(var(--color-brand-1-rgb), 0.4);
        }
      }
    }

    .item-actions {
      position: absolute;
      right: 12px;
      top: 12px;
      transform: translateX(8px);
      display: flex;
      gap: 6px;
      opacity: 0;
      transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      z-index: 2;

      .action-btn {
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.86);
        border-radius: var(--radius-s);
        color: rgba(34, 34, 34, 0.34);
        transition: var(--transition-base);
        position: relative; /* 涓虹姸鎬佺偣瀹氫綅 */
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

        &.shortcut {
          &.has-shortcut {
            color: var(--brand-color-pure);
            background: rgba(255, 255, 255, 0.88);
          }

          &.success::after {
            content: '';
            position: absolute;
            top: 2px;
            right: 2px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #4caf50;
            border: 1px solid #fff;
          }
        }

        &:hover {
          background: rgba(255, 255, 255, 0.96);
          color: var(--brand-color-pure);
          transform: scale(1.15);
        }

        &.delete:hover {
          background: #ff5757;
          color: #fff;
        }

        .svg_asset,
        svg {
          width: 13px;
          height: 13px;
        }
      }
    }

    &:hover {
      background: rgba(255, 255, 255, 0.62);
      border-color: rgba(255, 255, 255, 0.42);
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);

      .item-actions {
        opacity: 1;
        transform: translateX(0);
      }

      .item-name {
        color: var(--color-dark);
      }

      .item-meta {
        color: rgba(106, 114, 130, 0.9);
      }

      .item-progress {
        .item-progress-bar {
          width: 32%;
          opacity: 0.5;
        }
      }
    }

    &.active {
      background: rgba(255, 255, 255, 0.94);
      border-color: rgba(255, 255, 255, 0.9);
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(var(--color-brand-1-rgb), 0.12);

      .active-rail {
        transform: translateY(-50%) scaleY(1);
        box-shadow: 2px 0 14px rgba(var(--color-brand-1-rgb), 0.34);
      }

      .item-actions {
        opacity: 1;
        transform: translateX(0);

        .action-btn {
          background: rgba(var(--color-brand-1-rgb), 0.1);
          color: var(--brand-color-pure);

          &:hover {
            background: var(--brand-color-pure);
            color: #fff;
          }

          &.delete:hover {
            background: #ff5757;
            color: #fff;
          }
        }
      }

      .config-input {
        color: var(--brand-color-pure);
        border-bottom-color: var(--brand-color-pure);

        &::placeholder {
          color: rgba(var(--color-brand-1-rgb), 0.4);
        }
      }

      .item-name {
        color: var(--color-dark);
        font-weight: 900;
      }

      .item-meta {
        color: rgba(106, 114, 130, 0.72);
      }
      .item-progress {
        .item-progress-bar {
          width: 100%;
          opacity: 1;
          box-shadow: 0 0 12px rgba(var(--color-brand-2-rgb), 0.28);
        }
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 24px rgba(var(--color-brand-1-rgb), 0.14);
      }
    }

    &.add-config {
      background: rgba(255, 255, 255, 0.3);
      border: 1px dashed rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      color: var(--sidebar-text-muted);
      justify-content: center;
      gap: 8px;
      margin-top: 8px;
      padding: 14px 18px;

      .plus-icon {
        width: 16px;
        height: 16px;
        transition: transform 0.4s var(--transition-base);

        .svg_asset {
          width: 100%;
          height: 100%;
        }
      }

      span {
        font-size: 13px;
        font-weight: 700;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.72);
        border-color: rgba(var(--color-brand-1-rgb), 0.24);
        color: var(--brand-color-pure);
        transform: none;
        box-shadow: none;

        .plus-icon {
          transform: rotate(90deg) scale(1.2);
        }
      }
    }
  }

  .zoomer-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    margin: 0 12px 10px 12px;
    background: linear-gradient(135deg, var(--brand-color), var(--brand-color-pure));
    border-radius: var(--radius-m);
    color: #fff;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    box-shadow: 0 8px 20px rgba(var(--color-brand-1-rgb), 0.3); // 浣跨敤鍝佺墝鑹查槾褰?    position: relative;
    overflow: hidden;
    flex-shrink: 0; // 闃叉鍦ㄧ┖闂翠笉瓒虫椂琚帇缂?
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 30px rgba(var(--color-brand-1-rgb), 0.5);

      .zoomer-icon svg {
        transform: scale(1.1) rotate(5deg);
      }
    }

    .zoomer-icon {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      flex-shrink: 0;

      svg {
        width: 18px;
        height: 18px;
        stroke-width: 2.5;
        transition: transform 0.4s var(--transition-base);
      }
    }

    .zoomer-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 2px;

      .zoomer-title {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.3px;
      }

      .zoomer-desc {
        font-size: 11px;
        opacity: 0.85;
      }
    }
  }

  .config-footer {
    padding-top: 16px;
    margin-top: auto;

    .footer-btns {
      display: flex;
      gap: 10px;
      justify-content: space-between;

      :deep(.mgx_action_btn) {
        flex: 1;
        padding: 10px 8px;
        min-width: 0;
        height: 34px; /* 閿佸畾楂樺害鍑忓皬姣斾緥 */
        // padding: 0;
        font-size: 13px;
        background: rgba(255, 255, 255, 0.9);
        color: var(--color-dark);
        border-radius: var(--radius-m);

        &.primary {
          background: #fff; /* 搴曢儴鎸夐挳缁熶竴涓虹櫧搴曪紝鍑忓皯瑙嗚鏉傝壊 */
          color: var(--brand-color-pure);
          font-weight: 700;
        }

        .icon-wrapper {
          .svg_asset,
          svg {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
}

/* 鍔ㄧ敾瀹氫箟 */
@keyframes sidebar-in {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes footer-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(var(--color-brand-1-rgb), 0.7);
  }
  70% {
    transform: scale(1.2);
    opacity: 0.8;
    box-shadow: 0 0 0 10px rgba(var(--color-brand-1-rgb), 0);
  }
  100% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(var(--color-brand-1-rgb), 0);
  }
}

@media (max-width: 1560px) {
  .right-sidebar {
    padding: 14px;

    .config-header {
      padding: 0 2px 12px;
    }

    .config-item {
      padding: 16px 14px;
    }
  }
}

/* 鍒楄〃杩囨浮鍔ㄧ敾 */
.list-complete-enter-from,
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.list-complete-leave-active {
  position: absolute;
  width: calc(100% - 36px);
}
</style>
